import * as applicationSelectors from '../../api/lendingAPI/ApplicationSelector';
import {
    getAccountByProductType,
    getAllAccounts,
    REVENUE_BASED_LOAN_PRODUCT_TYPE
} from '../multiLoanDashboard/accountsSelector';
import { LOAN_STATUSES } from '../dashboard/constants';
import { MIN_DRAWDOWN_AMOUNT } from '../minDrawdownAmount';

export const hasRevenueBasedLoan = (state) => {
    const hasMultipleAccounts = getAllAccounts(state).length > 1;
    const rblAccount = getRBLAccount(state);
    if (!hasMultipleAccounts) {
        return (
            applicationSelectors.hasApplicationWithProductType(
                state,
                REVENUE_BASED_LOAN_PRODUCT_TYPE
            ) || !!rblAccount
        );
    }

    const flexiLoanAccount = getAllAccounts(state).filter(
        ({ product_type }) => product_type !== REVENUE_BASED_LOAN_PRODUCT_TYPE
    );
    return !(
        (!rblAccount || rblAccount?.loan_status === LOAN_STATUSES.ENDED) &&
        flexiLoanAccount.length
    );
};

function getRBLAccount(state) {
    return getAccountByProductType(state, REVENUE_BASED_LOAN_PRODUCT_TYPE);
}

function isTopUpEligible(state) {
    const account = getRBLAccount(state);
    return account.topup_eligibility?.is_allowed;
}

const canTopUpNow = (state) => {
    const account = getRBLAccount(state);
    return (
        account.topup_eligibility?.is_allowed &&
        account.topup_eligibility.amount_to_repay_before_topup === 0
    );
};

const hasAvailableCash = (state) => {
    const account = getRBLAccount(state);
    return account.latest_formal_offer.available_cash >= MIN_DRAWDOWN_AMOUNT;
};

export const canTopUpAfterRepayments = (state) =>
    !canTopUpNow(state) && isTopUpEligible(state) && !hasAvailableCash(state);

export const amountToRepayBeforeTopUp = (state) => {
    const account = getRBLAccount(state);
    return account.topup_eligibility?.amount_to_repay_before_topup;
};
